import { render } from "./clientskanban.vue?vue&type=template&id=415a1fdc"
import script from "./clientskanban.vue?vue&type=script&lang=js"
export * from "./clientskanban.vue?vue&type=script&lang=js"

import "./clientskanban.vue?vue&type=style&index=0&id=415a1fdc&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__